(() => {
    const rafThrottle = (fn) => {
      let raf = null;
      return (...args) => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = null;
          fn(...args);
        });
      };
    };
  
    function clamp(n, min, max) {
      return Math.max(min, Math.min(max, n));
    }
  
    function readPxVar(el, name) {
      const v = getComputedStyle(el).getPropertyValue(name).trim();
      const n = parseInt(v, 10);
      return Number.isFinite(n) ? n : 0;
    }
  
    function initFTG(section) {
      const canvas = section.querySelector('[data-ftg-canvas]');
      if (!canvas) return;
  
      const items = () => [...canvas.querySelectorAll('[data-ftg-item]')];
  
      const getGapY = () => readPxVar(section, '--ftg-gap');    // vertical gap
      const getGapX = () => readPxVar(section, '--ftg-gap-x');  // horizontal gap
  
      const getBreakpoint = () => {
        const n = parseInt(section.dataset.mobileBreakpoint, 10);
        return Number.isFinite(n) ? n : 750;
      };
  
      const layout = () => {
        const els = items();
        const gapY = getGapY();
        const gapX = getGapX();
  
        const breakpoint = getBreakpoint();
        const isMobile = window.innerWidth <= breakpoint;
  
        const colCount = isMobile ? 1 : 4;
        const colHeights = new Array(colCount).fill(0);
  
        const canvasWidth = canvas.clientWidth || section.clientWidth;
  
        // Account for horizontal gaps between columns
        const totalGapX = gapX * (colCount - 1);
        const colWidth = (canvasWidth - totalGapX) / colCount;
  
        els.forEach((el) => {
          let start = parseInt(el.dataset.colStart, 10);
          let span = parseInt(el.dataset.colSpan, 10);
  
          if (!Number.isFinite(start)) start = 1;
          if (!Number.isFinite(span)) span = 1;
  
          start = clamp(start, 1, colCount);
          span = clamp(span, 1, colCount);
  
          const startIdx = start - 1;
          const maxSpan = colCount - startIdx;
          span = Math.min(span, maxSpan);
  
          const endIdx = startIdx + span;
  
          const y = Math.max(...colHeights.slice(startIdx, endIdx));
  
          // x uses column width + gapX
          const x = startIdx * (colWidth + gapX);
  
          // width includes the internal gaps for spanning items
          const w = colWidth * span + gapX * (span - 1);
  
          el.style.width = `${w}px`;
          el.style.transform = `translate(${x}px, ${y}px)`;
  
          const h = el.offsetHeight + gapY;
          for (let i = startIdx; i < endIdx; i += 1) {
            colHeights[i] = y + h;
          }
        });
  
        canvas.style.height = `${Math.max(0, Math.max(...colHeights) - gapY)}px`;
      };
  
      const relayout = rafThrottle(layout);
  
      // Relayout after images load
      const imgs = canvas.querySelectorAll('img');
      imgs.forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', relayout, { passive: true });
        img.addEventListener('error', relayout, { passive: true });
      });
  
      // Observe size changes of the canvas
      const ro = new ResizeObserver(relayout);
      ro.observe(canvas);
  
      window.addEventListener('resize', relayout, { passive: true });
  
      // Initial
      relayout();
  
      section.__ftgDestroy = () => {
        try { ro.disconnect(); } catch (e) {}
        window.removeEventListener('resize', relayout);
        imgs.forEach((img) => {
          img.removeEventListener('load', relayout);
          img.removeEventListener('error', relayout);
        });
      };
    }
  
    function initAll(root = document) {
      root.querySelectorAll('[data-ftg]').forEach((section) => {
        if (section.__ftgDestroy) section.__ftgDestroy();
        initFTG(section);
      });
    }
  
    document.addEventListener('DOMContentLoaded', () => initAll());
  
    document.addEventListener('shopify:section:load', (e) => initAll(e.target));
    document.addEventListener('shopify:section:reorder', () => initAll());
    document.addEventListener('shopify:block:select', (e) => initAll(e.target));
    document.addEventListener('shopify:block:deselect', (e) => initAll(e.target));
  })();